export default "__VITE_ASSET__DbWH5nO3__"